export default __webpack_public_path__ + "static/media/gif3.138a7257.gif";